import { __rest } from "tslib";
import * as React from 'react';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/esm/icons/times-icon';
export var ModalBoxCloseButton = function ModalBoxCloseButton(_a) {
  var _a$className = _a.className,
    className = _a$className === void 0 ? '' : _a$className,
    _a$onClose = _a.onClose,
    onClose = _a$onClose === void 0 ? function () {
      return undefined;
    } : _a$onClose,
    ouiaId = _a.ouiaId,
    props = __rest(_a, ["className", "onClose", "ouiaId"]);
  return React.createElement(Button, Object.assign({
    className: className,
    variant: "plain",
    onClick: onClose,
    "aria-label": "Close"
  }, ouiaId && {
    ouiaId: "".concat(ouiaId, "-").concat(ModalBoxCloseButton.displayName)
  }, props), React.createElement(TimesIcon, null));
};
ModalBoxCloseButton.displayName = 'ModalBoxCloseButton';